// src/App.js
import React from "react";
import AppRoutes from "routes";
import { Toaster } from "react-hot-toast";
import { InstallPromptModal } from "components/InstallPromptModal";

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
          error: {
            duration: 5000,
          },
        }}
      />
      <InstallPromptModal />
      <AppRoutes />
    </>
  );
}

export default App;
